<template>
  <div class="works-type-select">
    <div
      v-for="(item, index) in radioText"
      :key="item"
      :class="{ active: index === searchWorksType }"
      @click="click(item, index)"
    >
      <div>{{ item }}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    return {
    }
  },
  computed: {
    ...mapState(["radioText", "searchWorksType"])
  },
  watch: {},
  created() { },
  mounted() { },
  methods: {
    ...mapMutations(["setSearchWorksType"]),
    click(item, index) {
      const oldIndex = this.searchWorksType;
      this.setSearchWorksType(index);
      this.$router.push(`/works/${index}`)
      if (oldIndex !== index) {
        this.$emit("change")
        // console.log(index);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.works-type-select {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  & > div {
    width: 100px;
    height: 40px;
    border: 1px solid #ebebeb;
    border-right: none;
    background-color: #ffffff;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    &:focus {
      color: #003588;
    }
  }
  .active {
    color: #fff;
    background-color: #003588;
  }
  & > div:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  & > div:last-child {
    border-right: 1px solid #ebebeb;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
</style>
